
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import ModelParams from "./components/model-params.vue";
import MaintenanceItem from "./components/maintenance-item.vue";
import MaintenanceMileage from "./components/maintenance-mileage.vue";
import dayjs from "dayjs";

const guidance = namespace("guidance");
const base = namespace("base");
const customer = namespace("customer");
@Component({
  components: { GeneralVehicleSelect, ModelParams, MaintenanceItem, MaintenanceMileage }
})
export default class GuidanceIndex extends Vue {
  @guidance.Action queryVehicleModelDetail;
  @guidance.Action queryMaintenanceItem;
  @guidance.Action queryRemainderOverview;
  @guidance.Action queryMileageCycles;
  @guidance.Action queryMonthCycles;
  @guidance.Action queryAccessScopeList;
  @customer.Action getCustomerDetail;
  @base.Action getVehicleInfoByVin;
  emptyToLine = emptyToLine;
  t = t;
  currentTabType: string = "vehicle";
  filterData: any = {
    modelCode: "",
    vinCode: ""
  };
  vehicleInfo: any = {};
  vehicleListByVin: any = [];
  showSelectVehicleMode: boolean = false;
  get tabBarData() {
    return [
      { tabName: t("v210831.vehicle-type-query"), type: "vehicle" },
      { tabName: t("v210831.vin-code-query"), type: "vin" }
    ];
  }
  curCategoryType: string = "1";
  created() {
    this.init();
  }
  defaultVehicleList: any = [];
  remainData: any = {};
  accessList = [];
  init() {
    const customerCode = this.$route.query.customerCode;
    const vehicleCode = this.$route.query.vehicleCode;
    if (customerCode && vehicleCode && vehicleCode !== "null" && vehicleCode !== "undefined") {
      this.getCustomerDetail({
        customerCode,
        vehicleCode
      }).then(data => {
        const vehicleData = data.data.vehicleList.find(item => item.vehicleCode === vehicleCode);
        this.filterData.modelCode = vehicleData.modelCode;
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
      });
    } else {
      setTimeout(() => {
        this.$nextTick(() => {
          (this.$refs.vehicleSelector as any).expandSelector();
        });
      }, 300);
    }
    this.getRemainderOverview();
    this.queryAccessScopeList().then(data => {
      this.accessList = data.data;
    });
  }
  getRemainderOverview() {
    this.queryRemainderOverview().then(data => {
      this.remainData = data.data;
    });
  }
  vehicleDataFormat(data) {
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandName, item.seriesName, item.modelCode]
    }));
  }
  searchVehicleByVinCode() {
    if (!this.filterData.vinCode) return;
    this.getVehicleInfoByVin({
      vinCode: this.filterData.vinCode
    }).then(
      data => {
        if (data.data.length > 1) {
          this.showSelectVehicleMode = true;
          this.vehicleListByVin = data.data;
        } else if (data.data.length === 1) {
          this.handleSelectVehiclebyVin(data.data[0]);
        }
        this.getRemainderOverview();
      },
      data => {
        this.$message.error(data.message);
      }
    );
  }
  handleSelectVehiclebyVin(vehicleData) {
    this.filterData.modelCode = vehicleData.modelCode;
    this.getModelParamsData("selectVin", vehicleData.modelCode);
  }
  get categoryTabData() {
    return [
      { tabName: t("v218_0.vehicle-model-parameters"), type: "1" },
      { tabName: t("v218_0.maintenance-items"), type: "2" },
      { tabName: t("v218_0.maintenance-mileage"), type: "3" },
      { tabName: t("v218_0.maintenance-cycle"), type: "4" }
    ];
  }
  pageStatus: string = "init"; // init  query
  handleSwitchStatus(tab) {
    if (tab.type === "vin" && !this.accessList.includes("VIN")) {
      return this.$message.error(t("v218_0.no-permission-at-the-moment-please-customer-service"));
    }
    this.currentTabType = tab.type;
  }
  handleSwichCategory({ type }) {
    if (type === "1") {
      this.getModelParamsData("switchTab");
    } else if (type === "2") {
      this.getMaintenanceItem();
    } else if (type === "3") {
      this.getMaintenanceMileageData();
    } else if (type === "4") {
      this.getMonthCycles();
    }
    this.curCategoryType = type;
  }

  handelInitType() {
    this.currentTabType = this.currentTabType === "vehicle" ? "vin" : "vehicle";
    if (this.currentTabType === "vehicle") {
      if (this.filterData.modelCode) {
        // this.getModelParamsData();
      }
    } else {
      if (this.filterData.vinCode) {
        // this.searchVehicleByVinCode();
      }
    }
  }

  modelParamsData: any = {};
  needQuery = false;
  getModelParamsData(action = "other", modelCode?) {
    // action: switchTab - 切换tab, selectVin - 选择vin码, ohter - 其他
    if (action === "switchTab" && Object.keys(this.modelParamsData).length > 0) return;
    modelCode = modelCode || this.filterData.modelCode;
    return this.queryVehicleModelDetail({
      modelCode: modelCode,
      vinCode: this.currentTabType === "vin" ? this.filterData.vinCode : ""
    }).then(data => {
      this.pageStatus = "query";
      data.data.lastUpdateTime = dayjs(data.data.lastUpdateTime).format("YYYY-MM-DD HH:mm:ss");
      data.data.modelCode = modelCode;
      this.modelParamsData = data.data;
      this.clearTabData();
      this.getRemainderOverview();
      if (action === "selectVin") {
        this.showSelectVehicleMode = false;
      }
      return data;
    });
  }
  maintenanceItemData: any = {};
  getMaintenanceItem() {
    if (Object.keys(this.maintenanceItemData).length > 0) return;
    this.queryMaintenanceItem({
      modelCode: this.filterData.modelCode
    }).then(data => {
      this.maintenanceItemData = data.data;
      this.getRemainderOverview();
    });
  }
  maintenanceMileageData: any = {};
  getMaintenanceMileageData() {
    if (Object.keys(this.maintenanceMileageData).length > 0) return;
    return this.queryMileageCycles({
      modelCode: this.filterData.modelCode
    }).then(data => {
      this.maintenanceMileageData = data.data;
      this.getRemainderOverview();
    });
  }
  maintenanceMonthCyclesData: any = {};
  getMonthCycles() {
    if (Object.keys(this.maintenanceMonthCyclesData).length > 0) return;
    return this.queryMonthCycles({
      modelCode: this.filterData.modelCode
    }).then(data => {
      this.maintenanceMonthCyclesData = data.data;
      this.getRemainderOverview();
    });
  }
  clearTabData() {
    this.maintenanceItemData = {};
    this.maintenanceMileageData = {};
    this.maintenanceMonthCyclesData = {};
  }
  handleQueryConstructionInfo() {
    if (this.currentTabType === "vehicle") {
      if (!this.filterData.modelCode) {
        return this.$message.error(t("test.select-car-model"));
      }
      if (this.filterData.modelCode === this.modelParamsData.modelCode) {
        return;
      }
    } else {
      if (!this.filterData.vinCode) {
        return this.$message.error(t("v210831.please-enter-the-vin"));
      }
    }
    this.curCategoryType = "1";
    if (this.currentTabType === "vehicle") {
      this.getModelParamsData();
    } else {
      this.searchVehicleByVinCode();
    }
  }
}
